import { Link as RouterLink } from 'react-router-dom'
import type { FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'
import { StyledIcon, StyledLink, StyledList } from './styles'
import type { ContentLink } from '../../config/content-links'
import ChevronRight from '../../assets/icons/chevronRight.svg'
import FAQ from '../../assets/icons/chatBubblePeople.svg'
import ICircle from '../../assets/icons/iCircle.svg'
import Email from '../../assets/icons/email.svg'
import Github from '../../assets/icons/gitHub.svg'
import Linkedin from '../../assets/icons/linkedIn.svg'
import Facebook from '../../assets/icons/facebook.svg'
import XLogo from '../../assets/icons/xLogo.svg'
import { Variant } from '../Links/Link/Link'
import ListItem from '../List/ListItem'

const StyledChevronRight = styled(ChevronRight)`
  fill: var(--light);
  width: 1rem;
  height: 1rem;
  margin-right: 0.5rem;
`

export interface FooterLinksProps {
  links: ContentLink[]
  isRow?: boolean
  children?: ReactNode
}

const getIcon = (icon: string) => {
  switch (icon) {
    case 'icircle':
      return <ICircle />
    case 'chatBubblePeople':
      return <FAQ />
    case 'email':
      return <Email />
    case 'x':
      return <XLogo />
    case 'github':
      return <Github />
    case 'linkedin':
      return <Linkedin />
    case 'facebook':
      return <Facebook />
    default:
      return null
  }
}

const FooterLinks: FunctionComponent<FooterLinksProps> = ({ children, links, isRow }) => (
  <StyledList isRow={isRow}>
    {links.map((link) => {
      const title = `Volg ons op ${link.title}`
      if ('href' in link) {
        return (
          <ListItem key={link.href}>
            <StyledLink
              variant={Variant.Basic}
              href={link.href}
              title={title}
              rel="external noopener noreferrer"
              target="_blank"
              data-testid={`footerLink${link.testId ?? ''}`}
            >
              {link.icon && <StyledIcon>{getIcon(link.icon)}</StyledIcon>}
              {!link.icon && <StyledChevronRight />}
              <span className="hrefLink">{link.title}</span>
            </StyledLink>
          </ListItem>
        )
      }

      return (
        <ListItem key={link.testId}>
          <StyledLink
            forwardedAs={RouterLink}
            to={link.slug}
            data-testid={`footerLink${link.testId ?? ''}`}
          >
            {link.icon && <StyledIcon>{getIcon(link.icon)}</StyledIcon>}
            {!link.icon && <StyledChevronRight />}
            <span>{link.title}</span>
          </StyledLink>
        </ListItem>
      )
    })}
    {children}
  </StyledList>
)

export default FooterLinks
